import styled from "@emotion/styled";
import { Checkbox, DropDown, Input, RangeCalendar } from "@src/components";
import { Common } from "@src/styles/Common";
import { ConvertDate, dateParse } from "@src/utils/dateUtil";
import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from "react";
import { userExpertListDto } from "./types";
import { ExpertApprovalType, getExpertApprovalListParams } from "@src/hooks/queries/useExpertApprovalList";
import { useDebounce } from "@src/hooks/useDebounce";

type ExpertApprovalFilterProps = {
    filters: getExpertApprovalListParams;
    setFilters: Dispatch<SetStateAction<getExpertApprovalListParams>>;
};

const dropList: {
    id: number;
    key: string;
    value: string;
}[] = [
    { id: 0, key: "선택", value: "선택" },
    { id: 1, key: "user_info.uname", value: "이름" },
    { id: 2, key: "user_info.phone", value: "연락처" },
    { id: 3, key: "user_info.id", value: "이메일" },
];

const ExpertApprovalTypeList = [
    { id: 0, key: "경매대행", value: "경매대행" },
    { id: 1, key: "매물컨설팅", value: "매물컨설팅" },
    { id: 2, key: "매수신청대리인", value: "매수신청대리인" },
];

const ExpertApprovalFilter = ({ filters, setFilters }: ExpertApprovalFilterProps) => {
    const dateLabel = [
        //날짜 라디오 버튼
        { id: 0, key: 0, value: "전체" },
        { id: 1, key: 1, value: "오늘" },
        { id: 2, key: 2, value: "7일" },
        { id: 3, key: 3, value: "1개월" },
        { id: 4, key: 4, value: "6개월" },
        { id: 5, key: 5, value: "12개월" },
    ];

    const [tempKeyword, setTempKeyword] = useState<string>("");
    const debouncedKeyword = useDebounce(tempKeyword, 300);

    useEffect(() => {
        setFilters({
            ...filters,
            searchKeyword: debouncedKeyword,
        });
    }, [debouncedKeyword]);

    const TODAY = ConvertDate(new Date().getTime());
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const day = new Date().getDate();
    const before7day = ConvertDate(new Date(year, month, day - 7).getTime());
    const before1Month = ConvertDate(new Date(year, month - 1, day).getTime());
    const before6Month = ConvertDate(new Date(year, month - 6, day).getTime());
    const before12Month = ConvertDate(new Date(year - 1, month, day).getTime());
    const [selectedDate, setSelectedDate] = useState<number | null>(0);

    const renderDate = (item: number) => {
        if (item == 0) {
            setFilters({
                ...filters,
                searchStartDate: "",
                searchEndDate: "",
            });
        } else if (item == 2) {
            setFilters({
                ...filters,
                searchStartDate: before7day,
                searchEndDate: TODAY,
            });
        } else if (item == 3) {
            setFilters({
                ...filters,
                searchStartDate: before1Month,
                searchEndDate: TODAY,
            });
        } else if (item == 4) {
            setFilters({
                ...filters,
                searchStartDate: before6Month,
                searchEndDate: TODAY,
            });
        } else if (item == 5) {
            setFilters({
                ...filters,
                searchStartDate: before12Month,
                searchEndDate: TODAY,
            });
        } else {
            // 오늘
            setFilters({
                ...filters,
                searchStartDate: TODAY,
                searchEndDate: TODAY,
            });
        }
        setSelectedDate(item);
    };

    const tryChangeCounselingChecked = (value: ExpertApprovalType) => {
        const updated = filters.type.includes(value)
            ? filters.type.filter((type) => type !== value)
            : [...filters.type, value];

        setFilters({
            ...filters,
            type: updated,
        });
    };

    return (
        <>
            <StyledExpertUserFilter>
                <ul>
                    <li>
                        <span className="subTitle">요청 일시</span>
                        <div>
                            {dateLabel.map((item) => (
                                <div key={item.id}>
                                    <button
                                        value={item.value}
                                        className={"datebtn" + (item.key == selectedDate ? " active" : "")}
                                        onClick={() => renderDate(item.key)}
                                    >
                                        {item.value}
                                    </button>
                                </div>
                            ))}
                            <RangeCalendar
                                setRangeDate={{
                                    startDate:
                                        filters.searchStartDate !== null && filters.searchStartDate !== undefined
                                            ? dateParse(filters.searchStartDate)
                                            : null,

                                    endDate:
                                        filters.searchEndDate !== null && filters.searchEndDate !== undefined
                                            ? dateParse(filters.searchEndDate)
                                            : null,
                                }}
                                getUserRangeDate={(date, isError) => {
                                    const { startDate: start, endDate: end } = date;
                                    setFilters({
                                        ...filters,
                                        searchStartDate: start ? ConvertDate(start) : "",
                                        searchEndDate: end ? ConvertDate(end) : "",
                                    });
                                }}
                                verticalAlign={false}
                                isDisabled={false}
                                timePicker={false}
                                clear={false}
                            />
                        </div>
                    </li>

                    <li>
                        <span className="subTitle">검색</span>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <DropDown
                                handleChange={(e, text, value) => {
                                    value &&
                                        setFilters({
                                            ...filters,
                                            searchType: value,
                                            searchKeyword: "",
                                        });
                                    setTempKeyword("");
                                }}
                                data={dropList}
                                // value={filters.searchType ?? ""}
                            />
                            <Input
                                label=""
                                value={tempKeyword}
                                name="searchInput"
                                type="text"
                                size="medium"
                                handleChange={(e) => {
                                    setTempKeyword(e.target.value);
                                }}
                                isDisabled={false}
                                errorMessage=""
                                placeholder="이름, 이메일, 연락처를 입력하세요"
                            />
                        </div>
                    </li>
                </ul>
            </StyledExpertUserFilter>
        </>
    );
};
export default ExpertApprovalFilter;

const StyledExpertUserFilter = styled.div`
    margin-top: 20px;
    width: 100%;
    padding: 16px 24px;
    border-radius: 8px;
    background-color: ${Common.colors.gray100};
    li {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 12px;
        &:last-of-type {
            margin-bottom: 0;
        }
        > div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
    }
    .subTitle {
        ${Common.textStyle.title6_R14}
        color: ${Common.colors.black};
        display: inline-block;
        width: 80px;
    }
    select {
        border-width: 1px;
    }
    input[name="searchInput"] {
        height: 36px;
        border: 1px solid ${Common.colors.gray200};
        border-radius: 8px;
        &::placeholder {
            color: ${Common.colors.gray500};
        }
    }
    .chkBoxDivWrap {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
    }
    .chkBoxDiv {
        display: flex;
    }
    .chkBoxDiv > div {
        margin-right: 16px;
    }
    .datebtn {
        padding: 10px;
        margin: 5px;
        background-color: white;
        border: 1px solid gray;
        cursor: pointer;
        border-radius: 8px;
    }
    .datebtn.active {
        font-weight: 700;
    }
`;
